import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { zlink, baseURL } from "../../../service/HttpService";
import { AppThunk } from "../../store";

export interface SalesActivityState {
    errors: any;
    branchOfficeListForSystemReport: any;
    panelTypeForSystemReport: any;
    selectedBranchOfficeListForSystemReport: any;
    selectedPanelTypeForSystemReport: any;
    selectedSystemStatusForSystemReport: any;
}

let initialState: SalesActivityState = {
    errors: "",
    branchOfficeListForSystemReport: [],
    panelTypeForSystemReport: [],
    selectedBranchOfficeListForSystemReport: [],
    selectedPanelTypeForSystemReport: [],
    selectedSystemStatusForSystemReport: []
};

const SystemreportState = createSlice({
    name: "systemReport",
    initialState,
    reducers: {
        setErrors: (state, { payload }: PayloadAction<any>) => {
            state.errors = payload;
        },
        setBranchOfficeListForSystemReport: (state, { payload }: PayloadAction<any>) => {
            state.branchOfficeListForSystemReport = payload;
        },
        setPanelTypeForSystemReport: (state, { payload }: PayloadAction<any>) => {
            state.panelTypeForSystemReport = payload;
        },
        setSelectedBranchOfficeListForSystemReport: (state, { payload }: PayloadAction<any>) => {
            state.selectedBranchOfficeListForSystemReport = payload;
        },
        setSelectedPanelTypeForSystemReport: (state, { payload }: PayloadAction<any>) => {
            state.selectedPanelTypeForSystemReport = payload;
        },
        setSelectedSystemStatusForSystemReport: (state, { payload }: PayloadAction<any>) => {
            state.selectedSystemStatusForSystemReport = payload;
        }
    },
});

export const getBranchOfficeListForSystemReport = (): AppThunk =>
    async (dispatch) => {
        try {
            const res = await zlink.get(`${baseURL}api/v1/systemreport/branchofficelist`);
            if (res.status === "done") {
                if (res.data) {
                   
                    dispatch(setBranchOfficeListForSystemReport(res?.data));
                }
            } else {
                dispatch(setErrors(res.error));
            }
        } catch (error) {
            dispatch(setErrors(error));
        }
    };

export const getPanelTypeListForSystemReport = (body: any): AppThunk => async (dispatch) => {
    try {
        const res = await zlink.post(`${baseURL}api/v1/systemreport/paneltypelist`, body);
        if (res.status === "done") {
            dispatch(setPanelTypeForSystemReport(res.data));
        } else {
            dispatch(setErrors(res.error));
        }
    } catch (error) {
        dispatch(setErrors(error));
    }
};

export const {
    setErrors,
    setBranchOfficeListForSystemReport,
    setPanelTypeForSystemReport,
    setSelectedBranchOfficeListForSystemReport,
    setSelectedPanelTypeForSystemReport,
    setSelectedSystemStatusForSystemReport
} = SystemreportState.actions;
export default SystemreportState.reducer;